const lstore = window.localStorage
const lsession = window.sessionStorage
const STORAGE_KEY = 'bzy__visitor__'

export default {
    getVisitor (id) {
        let session = lsession.getItem(STORAGE_KEY + id)
        let visitor = lstore.getItem(STORAGE_KEY + id)
        if (visitor) {
            visitor = JSON.parse(visitor)
            visitor.first_visit = false
        } else {
            visitor = {
                first_visit: true,
                browser_language: navigator.language,
                number_of_page_views: 0,
                time_on_current_page: new Date().getTime(),
                number_of_visits: 0,
                candidate: {
                    email_address: '',
                    resume: {},
                    start_id: null
                },
                options: {
                    ding_muted: false,
                    open: false,
                }
            }
        }
        if (!session) {
            visitor.number_of_visits++
            this.setSession(id)
        }
        //console.log(JSON.stringify(visitor))
        return visitor
    },
    setVisitor (id, visitor) {
        visitor = JSON.stringify(visitor)
        let data = {
            type: 'update',
            payload: visitor
        }
        parent.postMessage(data, '*')
        lstore.setItem(STORAGE_KEY + id, visitor)
    },
    setSession (id) {
        lsession.setItem(STORAGE_KEY + id, new Date().getTime())
    }
}


// WEBPACK FOOTER //
// ./src/services/visitor.js